import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlagViolence = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.7076 9.80175L7.95759 19.1768C7.86487 19.2757 7.74247 19.3418 7.60888 19.3651C7.47528 19.3884 7.33773 19.3676 7.21699 19.3059C7.09625 19.2441 6.99886 19.1448 6.93953 19.0229C6.88019 18.9009 6.86213 18.763 6.88806 18.6299L8.03338 12.901L3.53103 11.2103C3.43434 11.1742 3.34811 11.1146 3.28005 11.037C3.21199 10.9594 3.16422 10.8661 3.14101 10.7655C3.11779 10.6649 3.11986 10.5601 3.14702 10.4605C3.17418 10.3609 3.22559 10.2696 3.29666 10.1947L12.0467 0.819721C12.1394 0.720764 12.2618 0.654652 12.3954 0.631359C12.529 0.608067 12.6665 0.628858 12.7873 0.690597C12.908 0.752335 13.0054 0.851671 13.0647 0.973613C13.1241 1.09555 13.1421 1.23349 13.1162 1.3666L11.9678 7.10175L16.4701 8.79004C16.5661 8.82645 16.6516 8.88594 16.7191 8.96326C16.7867 9.04058 16.8341 9.13334 16.8573 9.23335C16.8805 9.33335 16.8786 9.43753 16.852 9.53666C16.8253 9.6358 16.7747 9.72685 16.7045 9.80175H16.7076Z",
		fill: "current"
	})
});
export default SvgFlagViolence;
